import { data } from "isotope-layout";
import { actionHandler } from "../api";
const SearchUrl = `api/method/guidestar.api.npo_profile.npo_profile_search`
const StateUrl = `api/method/guidestar.api.npo_profile_advance_search.get_npo_profile_state_list?`
const districtUrl = `api/method/guidestar.api.npo_profile_advance_search.get_npo_profile_district_list?`
const populationsUrl = `api/method/guidestar.api.npo_profile_advance_search.get_populations_segments_list?`
const causeUrl = `api/method/guidestar.api.npo_profile_advance_search.get_cause_thematic_list?`
const GetCountUrl = `/api/method/guidestar.api.user_view_status.get_user_viewed_status`
const SearchPostUrl = `api/method/guidestar.api.npo_profile_advance_search.get_npo_profile_advance_search`;
const postCountUrl = `api/method/guidestar.api.user_view_status.post_user_viewed_status`;
const getIpUrl = `https://api64.ipify.org?format=json`;

const getSearchResults = async ({ searchKey, currentPage }) => {
  try {
    const trimmedKey = searchKey != null ? String(searchKey).trim() : '';
    if (!trimmedKey) {
      return { status_message: 'Not Found', total_count: 0, documents: [] };
    }
    const response = await actionHandler({
      url: `${SearchUrl}?keyword=${encodeURIComponent(trimmedKey)}&page_no=${currentPage || 1}`,
      method: 'GET'
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};

const getStates = async () => {
  try {
    const response = await actionHandler({
      url: StateUrl,
      method: 'GET'
    });
    
    return response?.data;
  } catch (error) {
    console.error("Error fetching states:", error);
    throw error;
  }
};

const getDistricts = async () => {
  try {
    const response = await actionHandler({
      url: `${districtUrl}`,
      method: 'GET'
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};

const getPopulations = async () => {
  try {
    const response = await actionHandler({
      url: `${populationsUrl}`,
      method: 'GET'
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};
const getCause = async () => {
  try {
    const response = await actionHandler({
      url: `${causeUrl}`,
      method: 'GET'
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};
const getCount = async (ip) => {
  try {
    const data = { ip_address: ip }
    const args = encodeURIComponent(JSON.stringify(data));
    const response = await actionHandler({
      url: `${GetCountUrl}?args=${args}`,
      method: 'GET'
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};
const postUserCountApi = async (payload) => {
  try {
    const response = await actionHandler({
      url: postCountUrl,
      method: 'POST',
      data: payload
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};
export const SearchPostCall = async (data) => { // Destructure key and data from the argument
  
  try {
    const args = encodeURIComponent(JSON.stringify(data));
    const response = await actionHandler({
      url: `${SearchPostUrl}?args=${args}`,
      method: 'GET',
    });

    return response.data; // Return the data directly
  } catch (error) {
    throw error; // Ensure you handle errors appropriately
  }
};
export const getIp = async () => { // Destructure key and data from the argument
  try {
    const response = await actionHandler({
      url: getIpUrl,
      method: 'GET',
    });

    return response.data; // Return the data directly
  } catch (error) {
    throw error; // Ensure you handle errors appropriately
  }
};

export { getSearchResults, getStates, getDistricts, getPopulations, getCause, getCount, postUserCountApi };

